import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

export default {
  getClientId () {
    return store.getters['Client/clientId']
  },
  getDeskGroups () {
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups`)
  },
  getDeskGroup (groupId) {
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups/${groupId}`)
  },
  getDeskGroupsBySite (siteId) {
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups/site/${siteId}`)
  },
  saveGroup (group) {
    if(group.id){
      return Axios.put(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups/${group.id}`, group)
    } else {
      return Axios.post(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups`, group)
    }
  },
  deleteGroup(groupId, cancelFutureBookings){
    return Axios.delete(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups/${groupId}?cancelFutureBookings=${cancelFutureBookings}`)
  },
  getFile() {
    let headers = {responseType: 'arraybuffer'}
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/desk-groups/file`, headers)
  }
}
